import React from 'react'
import {BookOpen, RefreshCw, Calculator, ListChecks, Bookmark, Search, Heart, Clock, Calendar, Sparkles} from 'lucide-react'

function AppSection() {
  const items = [
    { icon: BookOpen, text: 'Coloque pão quentinho na mesa sempre que quiser, sem culpa' },
    { icon: Heart, text: 'Prepare receitas que toda a família vai amar' },
    { icon: Clock, text: 'Cozinhe com liberdade, sem perder tempo' },
    { icon: Calendar, text: 'Saiba exatamente o que preparar todos os dias' },
    { icon: Bookmark, text: 'Tenha todas as receitas organizadas e sempre à mão' },
    { icon: Sparkles, text: 'Cozinhe com mais confiança e prazer' },
  ]

  const features = [
    { icon: RefreshCw, text: 'Sempre descubra novas receitas sem pagar novamente' },
    { icon: Calculator, text: 'Calcule porções sem errar a mão' },
    { icon: ListChecks, text: 'Nunca mais esqueça nenhum ingrediente' },
    { icon: Search, text: 'Encontre qualquer receita em poucos segundos' },
  ]

  return (
    <section className="bg-[#49352B] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <div className="flex justify-center animate-fade-up">
            <img
              src="https://static.lumi.new/03/03dea5c4a47c3244cec6d0e6a11afa87.png"
              alt="Aplicativo Forno Essencial"
              className="w-80 md:w-[24rem] h-auto object-cover rounded-[20px] shadow-2xl"
            />
          </div>

          <div className="animate-fade-up space-y-8">
            <div>
              <p className="text-[#D9891B] font-semibold uppercase tracking-wide text-sm mb-3">Liberdade para cozinhar</p>
              <h2 className="font-display text-white text-3xl md:text-5xl font-bold leading-tight">
                Sua transformação na cozinha, no bolso, 24 horas por dia
              </h2>
            </div>

            <div>
              <p className="text-white/60 text-sm font-semibold uppercase tracking-wide mb-4">O que o aplicativo proporciona</p>
              <div className="grid sm:grid-cols-2 gap-5">
                {items.map((item, i) => {
                  const Icon = item.icon
                  return (
                    <div key={i} className="flex items-center gap-4">
                      <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="w-5 h-5 text-[#D9891B]" />
                      </div>
                      <p className="text-white/85 text-base">{item.text}</p>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="pt-4 border-t border-white/10">
              <p className="text-white/60 text-sm font-semibold uppercase tracking-wide mb-4">Recursos do aplicativo</p>
              <div className="grid sm:grid-cols-2 gap-5">
                {features.map((item, i) => {
                  const Icon = item.icon
                  return (
                    <div key={i} className="flex items-center gap-4">
                      <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="w-5 h-5 text-[#D9891B]" />
                      </div>
                      <p className="text-white/85 text-base">{item.text}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AppSection
